import React, { createContext, useContext, useState } from "react";
import { useMQTTWithSubscription } from "@DATATERRAIN-INC/mqtt-layer"; // your custom hook
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateNotificationCount } from "./activities";
import { rtkQueryApiServices } from "./api";

const MQTTContext = createContext(null);

export const MQTTProvider = ({ children }) => {
  const dispatch = useDispatch();
   const [chatTabsCount,setChatTabsCount] = useState({});

  const handleNotificationCount = (count = 0) => {
    dispatch(
      updateNotificationCount({
        notificationCount: count,
      })
    );
  };

  const handleMessage = React.useCallback((topic, message) => {
    const msg = JSON.parse(message);
    if (msg?.type === "push") {
      handleNotificationCount(msg?.data?.notification_count);
      toast.success(msg?.data?.content);
    }
     else if (msg?.type === "live_count"){
       const message =   JSON.parse(
           msg?.data?.count
         )
        setChatTabsCount(message);
    }
    else if(msg?.type === "message"){
     const newMessage = JSON.parse(msg?.data?.message) 
     toast.success(`${newMessage?.content ?  `Message ${newMessage?.content} from ${newMessage?.sender?.first_name}` :`File ${newMessage.file_name} from chats`}`)
     dispatch(rtkQueryApiServices.util.invalidateTags(['Counts']));
    }
  }, []);

  const mqtt = useMQTTWithSubscription({
    options: {
      username: process.env.REACT_APP_CHAT_CLIENT_USERNAME,
      password: atob(process.env.REACT_APP_CHAT_CLIENT_PASSWORD),
      connectionUrl: process.env.REACT_APP_CHAT_CLIENT_URL,
      // keepalive: 100,
    },
    topics: [],
    onMessage: handleMessage,
  });

  return <MQTTContext.Provider value={{...mqtt,chatTabsCount}}>{children}</MQTTContext.Provider>;
};

export const useMQTTContext = () => {
  const context = useContext(MQTTContext);
  if (!context) {
    throw new Error("useMQTTContext must be used inside a <MQTTProvider>");
  }
  return context;
};
